import React from 'react';

const AddItemButton = ({ onClick, children }) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className="mt-6 w-full rounded-xl border-2 border-dashed border-white/15 bg-white/[0.02] py-3 text-sm font-semibold text-neutral-400 transition-colors hover:border-cyan-500/60 hover:bg-cyan-500/5 hover:text-cyan-300"
        >
            {children}
        </button>
    );
};

export default AddItemButton;
